/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ICreateInternalMappingsJobMutationVariables = Types.Exact<{
  input: Types.ICreateInternalMappingsJobInput;
}>;

export type ICreateInternalMappingsJobMutation = {
  __typename?: 'Mutation';
  createInternalMappingsJob: {
    __typename?: 'InternalMappingsJob';
    id: string;
    clientCode: string;
    regulationName: string;
    documentName?: string | null;
    createdAt: string;
    publishedAt?: string | null;
    status: Types.IInternalMappingsJobStatus;
  };
};

export const CreateInternalMappingsJobDocument = gql`
  mutation CreateInternalMappingsJob($input: CreateInternalMappingsJobInput!) {
    createInternalMappingsJob(input: $input) {
      id
      clientCode
      regulationName
      documentName
      createdAt
      publishedAt
      status
    }
  }
`;
export type ICreateInternalMappingsJobMutationFn = Apollo.MutationFunction<
  ICreateInternalMappingsJobMutation,
  ICreateInternalMappingsJobMutationVariables
>;

/**
 * __useCreateInternalMappingsJobMutation__
 *
 * To run a mutation, you first call `useCreateInternalMappingsJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInternalMappingsJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInternalMappingsJobMutation, { data, loading, error }] = useCreateInternalMappingsJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInternalMappingsJobMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateInternalMappingsJobMutation,
    ICreateInternalMappingsJobMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ICreateInternalMappingsJobMutation, ICreateInternalMappingsJobMutationVariables>(
    CreateInternalMappingsJobDocument,
    options,
  );
}
export type CreateInternalMappingsJobMutationHookResult = ReturnType<typeof useCreateInternalMappingsJobMutation>;
export type CreateInternalMappingsJobMutationResult = Apollo.MutationResult<ICreateInternalMappingsJobMutation>;
export type CreateInternalMappingsJobMutationOptions = Apollo.BaseMutationOptions<
  ICreateInternalMappingsJobMutation,
  ICreateInternalMappingsJobMutationVariables
>;
